import React, { useEffect, useState } from "react";
import { Star } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";

// Admin console: learner reviews waiting to be published as testimonials.
export const AdminReviews = () => {
  const [items, setItems] = useState(null);
  const load = () => api.get("/admin/reviews").then((r) => setItems(r.data.reviews)).catch(() => setItems([]));
  useEffect(() => { load(); }, []);
  const decide = (r, action) => api.post(`/admin/reviews/${r.id}`, { action }).then(() => { toast.success(action === "publish" ? "Published as a testimonial" : "Dismissed"); load(); })
    .catch((e) => toast.error(e.response?.data?.detail || "Couldn't update the review"));
  const pending = (items || []).filter((r) => r.status === "pending");
  return (
    <section className="mt-10 rounded-2xl border border-border bg-card p-5" data-testid="admin-reviews">
      <h2 className="font-serif text-2xl">Learner reviews {pending.length > 0 && <span className="ml-1 rounded-full bg-primary px-2 py-0.5 align-middle text-xs text-primary-foreground" data-testid="admin-reviews-pending">{pending.length} new</span>}</h2>
      <p className="mt-1 text-sm text-muted-foreground">Learners are asked for a review by email after their 5th lesson.</p>
      {items === null ? <p className="mt-3 text-sm">Loading…</p> : items.length === 0 ? <p className="mt-3 text-sm text-muted-foreground">No reviews yet.</p> : (
        <ul className="mt-3 divide-y divide-border">{items.map((r) => (
          <li key={r.id} className="py-3 text-sm" data-testid="admin-review-item">
            <div className="flex flex-wrap items-center justify-between gap-2">
              <p className="font-semibold">{r.display_name} <span className="font-normal text-muted-foreground">({r.email})</span> <span className="inline-flex align-middle">{Array.from({ length: r.rating }, (_, i) => <Star key={i} size={13} className="fill-primary text-primary" />)}</span></p>
              <span className="text-xs capitalize text-muted-foreground">{r.status}{!r.consent && " · not for publishing"}</span>
            </div>
            <p className="mt-1">“{r.quote}”</p>
            {r.status === "pending" && (
              <div className="mt-2 flex gap-2">
                {r.consent && <button type="button" onClick={() => decide(r, "publish")} data-testid="admin-review-publish" className="rounded-full bg-primary px-3 py-1 text-xs font-bold text-primary-foreground">Publish as testimonial</button>}
                <button type="button" onClick={() => decide(r, "dismiss")} data-testid="admin-review-dismiss" className="rounded-full border border-border px-3 py-1 text-xs font-semibold">Dismiss</button>
              </div>
            )}
          </li>
        ))}</ul>
      )}
    </section>
  );
};
